export class CompanyContact {
    id: number;
    empresaId: number;
    empresaNombre: string;
    nombre: string;
    cargo: string;
    email: string;
    telefono: number;
    movil: number;
    comentarios: string;
    options: string;
  }
  